export default __webpack_public_path__ + "static/media/block.adac6133.svg";